export default function getProjectStatus(status) {
    switch (status) {
        case 'CREATED':
            return { label: 'Not Started', color: 'info' };
        case 'RUNNING':
            return { label: 'Running', color: 'success' };
        case 'COMPLETED':
            return { label: 'Completed', color: 'primary' };
        case 'AWAITING_URL':
            return { label: 'Awaiting URL', color: 'warning' };
        case 'AWAITING_RESULT':
            return { label: 'Awaiting Result', color: 'warning' };
        case 'PENDING_ISSUE':
            return { label: 'Pending Issue', color: 'warning' };
        default:
            return { label: 'Unknown', color: 'default' };
    }
};